import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "smartsearch-serp q-bg-light q-pt-1" }
const _hoisted_2 = {
  key: 2,
  class: "smartsearch-serp__container q-container-xxl q-py-lg-1 q-d-flex"
}

import FiltersContainer from '@/components/SerpPage/FiltersContainer/FiltersContainer.vue'
import ResultsContainer from '@/components/SerpPage/ResultsContainer/ResultsContainer.vue'
import BackToTopButton from '@/components/BackToTopButton.vue'
import SearchInputContainer from '@/components/SerpPage/ResultsContainer/SearchInputContainer.vue'
import ResultsInfoWrapper from './ResultsInfoWrapper/ResultsInfoWrapper.vue'
import FiltersContainerTop from '@/components/SerpPage/FiltersContainer/FiltersContainerTop.vue'

import {onMounted, watch, inject, onUnmounted} from "vue";
import {storeToRefs} from "pinia";

import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {usePaginationStore} from "@/store/SerpPage/PaginationStore";
import {useSortingStore} from "@/store/SerpPage/SortingStore";
import {SmartSearchConfigInterface} from '@/core/types'
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useMobileViewStore} from "@/store/MobileViewStore";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const scrollPositionSessionKey = 'ss3_scroll_position'


export default /*@__PURE__*/_defineComponent({
  __name: 'SerpPage',
  setup(__props) {

const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')!

const paginationStore = usePaginationStore()
const sortingStore = useSortingStore();
const {page} = storeToRefs(paginationStore)
const {selectedSort} = storeToRefs(sortingStore)

const serpStore = useSerpResultsStore();
const {initialised, noResultsState, typeQueryState} = storeToRefs(serpStore)

const filtersStore = useFiltersStore();
const mobileViewStore = useMobileViewStore();
const {canShowFiltersOnMobile} = storeToRefs(filtersStore)
const {isTabletView} = storeToRefs(mobileViewStore)


const useBackToTopButton = SmartSearchConfig.value.serp.backToTopButton.enabled
const {showAsideFilters, showTopFilters} = SmartSearchConfig.value.serp.filters
const showInput = SmartSearchConfig.value.serp.showInput

const scrollToPosition = () => {
  const savedScrollTop = sessionStorage.getItem(scrollPositionSessionKey);
  if (savedScrollTop) {

    window.scrollTo(0, savedScrollTop);
  }
}

onMounted(async () => {
  window.addEventListener('resize', mobileViewStore.updateIsMobileView);

  await serpStore.getAndSetProducts('onMounted');
  scrollToPosition()
  initialised.value = true


  watch(selectedSort, () => {
    if (!sortingStore.shouldTriggerSelectedSortWatcher) {
      sortingStore.shouldTriggerSelectedSortWatcher = true;
      return;
    }

    serpStore.getAndSetProducts('selectedSort watcher');
  }, {immediate: false});

  watch(page, async () => {
    await serpStore.getAndSetProducts('page watcher');
  }, {immediate: false});

  window.addEventListener('popstate', () => {
    serpStore.getAndSetProducts('history event');
  });

  let lastScrollTop = 0;

  window.addEventListener('beforeunload', () => {
    lastScrollTop = window.scrollY
    sessionStorage.setItem(scrollPositionSessionKey, lastScrollTop);
  });

});


onUnmounted(() => {
  let lastScrollTop = 0;
  window.removeEventListener('beforeunload', () => {
    lastScrollTop = window.scrollY
    sessionStorage.setItem(scrollPositionSessionKey, lastScrollTop);
  });
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_unref(showInput))
      ? (_openBlock(), _createBlock(SearchInputContainer, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(ResultsInfoWrapper),
    ((!_unref(typeQueryState) && _unref(showTopFilters)) || _unref(isTabletView) )
      ? (_openBlock(), _createBlock(FiltersContainerTop, { key: 1 }))
      : _createCommentVNode("", true),
    (!_unref(typeQueryState))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_unref(noResultsState) && _unref(showAsideFilters) || (_unref(showTopFilters) && _unref(canShowFiltersOnMobile)))
            ? (_openBlock(), _createBlock(FiltersContainer, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(ResultsContainer)
        ]))
      : _createCommentVNode("", true),
    (_unref(useBackToTopButton))
      ? (_openBlock(), _createBlock(BackToTopButton, { key: 3 }))
      : _createCommentVNode("", true)
  ]))
}
}

})